import { ComponentProps, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

interface CheckBoxGroupProps extends ComponentProps<'div'> {}
function CheckBoxGroup({ className, ...rest }: CheckBoxGroupProps) {
  return <div className={twMerge('flex flex-col gap-2', className)} {...rest} />
}

interface CheckBoxLabelTextProps extends ComponentProps<'span'> {}
function CheckBoxLabelText({ className, ...rest }: CheckBoxLabelTextProps) {
  return (
    <span
      className={twMerge('font-bold text-monochromatic-500', className)}
      {...rest}
    />
  )
}

interface CheckBoxInputGroupProps extends ComponentProps<'div'> {}
function CheckBoxInputGroup({ className, ...rest }: CheckBoxInputGroupProps) {
  return (
    <div className={twMerge('flex items-center gap-2', className)} {...rest} />
  )
}

interface CheckBoxInputProps extends ComponentProps<'input'> {}
const CheckBoxInput = forwardRef<HTMLInputElement, CheckBoxInputProps>(
  ({ type = 'checkbox', ...rest }, ref) => {
    return <input type={type} ref={ref} {...rest} />
  },
)

CheckBoxInput.displayName = 'CheckBoxInput'

interface CheckBoxLabelProps extends ComponentProps<'label'> {}
function CheckBoxLabel({ className, ...rest }: CheckBoxLabelProps) {
  return (
    <label className={twMerge('text-monochromatic-500', className)} {...rest} />
  )
}

export {
  CheckBoxGroup,
  CheckBoxLabelText,
  CheckBoxInputGroup,
  CheckBoxInput,
  CheckBoxLabel,
}
